import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'link' })
export class LinkPipe implements PipeTransform {
  transform(htmlContent: string): any {
    return htmlContent?.replace(/<a/g, '<a target="_blank"');
  }
}

@NgModule({
  declarations: [LinkPipe],
  exports: [LinkPipe],
  providers: [LinkPipe],
  imports: [CommonModule],
})
export class LinkModule {}
